import { useEffect, useState, useContext } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { Link, useLocation } from "react-router-dom";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import Select from "../../Components/Select";
import Pagination from "../../Components/Pagination";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import StateTranslate from "../../Components/StateTranslate";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ListAnnouncements(props) {
  const apiToken = useContext(TokenContext);
  const [servicesList, setServicesList] = useState();
  const [isOpen, toggleModal] = useState(false);
  const [servizi, setServizi] = useState([]);
  const [servizioTemp, setServizioTemp] = useState();
  const [loading, setLoading] = useState(true);

  let query = useQuery();

  const [announcementsList, setAnnouncementsList] = useState();
  const [announcementsListTemp, setAnnouncementsListTemp] = useState();

  const [removableSession, setRemovableSession] = useState();

  useEffect(() => {
    setLoading(false);

    Repo.getAnnouncementsOperator(apiToken)
      .then((response) => {
        setAnnouncementsListTemp(response.data);
        setLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });

    Repo.getListaServizi(apiToken)
      .then((response) => {
        setServizi(response.data);
        setLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
  }, []);

  const filterSessions = (e) => {
    if (e) {
      let id = e.value;
      setServizioTemp(e.name);
      Repo.getAnnouncementsByServiceOperator(apiToken, id)
        .then((response) => {
          setAnnouncementsListTemp(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setServizioTemp();
      Repo.getAnnouncementsOperator(apiToken)
        .then((response) => {
          window.location.reload();
          setAnnouncementsListTemp(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const deleteSessione = () => {
    Repo.deleteSession(apiToken, removableSession)
      .then((response) => {
        if (response.status == 204) {
          window.location.reload();
          // setAnnouncementsListTemp(response);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const sessions = () => {
    return (
      <>
        {announcementsListTemp && announcementsListTemp.length > 0 ? (
          <>
            {/* Intestazione */}
            <div className="d-flex fw-bold border-bottom pb-2 mb-2">
              <div className="col-5">
                <strong>Titolo</strong>
              </div>
              <div className="col-3">
                <strong>Servizio</strong>
              </div>
              <div className="col">
                <strong>Stato</strong>
              </div>
              <div className="col text-end"></div>
            </div>

            {/* Lista elementi */}
            {announcementsList &&
              announcementsList.map((x, index) => (
                <div
                  key={index}
                  className="d-flex align-items-center py-2 border-bottom"
                  style={
                    x?.state === "ARCHIVED"
                      ? { backgroundColor: "#e8e9ea" }
                      : undefined
                  }
                >
                  <div className="col-5">{x.name}</div>
                  <div className="col-3">{x.service.name}</div>
                  <div className="col d-flex justify-content-center align-items-center">
                  <StateTranslate text={x.state} trasform="U" />
                </div>
                  <div className="col text-right">
                    <Link to={`/lista_bandi/dettaglio_sessione?id=${x.id}`}>
                      <button
                        className="btn btn-outline-primary p-1 mr-2"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Dettaglio"
                      >
                        <svg className="icon icon-primary">
                          <use href={`${iconSprite}#it-search`} />
                        </svg>
                      </button>
                    </Link>
                    {x?.state === "CREATE" && (
                      <button
                        className="btn btn-outline-danger p-1 mr-2"
                        type="button"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Elimina"
                        onClick={() => {
                          toggleModal(!isOpen);
                          setRemovableSession(x.id);
                        }}
                      >
                        <svg className="icon icon-danger">
                          <use href={`${iconSprite}#it-delete`} />
                        </svg>
                      </button>
                    )}
                  </div>
                </div>
              ))}

            {/* Paginazione */}
            {announcementsListTemp && (
              <Pagination
                items={announcementsListTemp}
                setCurrentItems={setAnnouncementsList}
                itemsPerPage={15}
              />
            )}
          </>
        ) : (
          <div className="text-center py-3">
            <b>Non sono presenti sessioni</b>
          </div>
        )}
      </>
    );
  };

  return (
    <>
      <div>
        <h1>Lista bandi</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>
            Tutti i bandi inseriti nel sistema: é possibile filtrare i bandi per
            servizio, visualizzare i dettagli ed eliminare un bando.{" "}
          </p>
        </div>

        <div className="row mt-4 mb-5 ">
          <div className="col-lg-10 clearfix">
            <div className="bootstrap-select-wrapper col-6">
              <Select
                aria-label="Servizio"
                clearText="Annulla"
                defaultMenuIsOpen={false}
                required
                icon={false}
                name="servizio"
                id="servizio"
                options={servizi}
                onChange={(e) => filterSessions(e)}
                isClearable
                isSearchable
                placeholder={
                  servizioTemp && servizioTemp
                    ? servizioTemp
                    : "Seleziona servizio"
                }
              />
            </div>
          </div>
          <div className="col-lg-2 clearfix">
            <Link to={"/lista_bandi/nuova_sessione"}>
              <button
                type="button"
                className="btn btn-outline-primary float-right p-2"
              >
                <svg className="icon icon-primary">
                  <use href={`${iconSprite}#it-plus-circle`} />
                </svg>{" "}
                <span className="align-middle">Nuovo bando</span>
              </button>
            </Link>
          </div>
        </div>
        {sessions()}
      </div>
      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Elimina Bando"
        body="Confermi di voler eliminare questo bando?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => deleteSessione()}
      ></ModalComponent>
      {!loading && <Loader></Loader>}
    </>
  );
}
export default ListAnnouncements;
